// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__1Bf0z","content":"Footer_content__3hdD7","links":"Footer_links__zdlrj","copyright":"Footer_copyright__YZgw_"};